import * as Teams from '@microsoft/teams-js';
import * as React from 'react';
import { LogCategory } from '../../../../logger';
import { getAppHost } from '../../../../utilities/TeamsUtils';
import { Spinner } from '../../../components';

export const DocusignLogoutEnd: React.FC = (): JSX.Element => {
    const logger = getAppHost().getLogger();
    const logCategory = LogCategory.DocusignAuth;
    logger.logTraceInfo(logCategory, 'Calling DocusignLogout');
    Teams.authentication.notifySuccess();

    return (
        <div style={{ height: '100vh' }}>
            <Spinner />
        </div>
    );
};
